import moment from "moment";

export const formatDateTimeShort = (date: Date) => {
  let returnDate = "";
  if (date) {
    const formatDate = moment.localeData().longDateFormat("L");
    const formatTime = moment.localeData().longDateFormat("LT");
    returnDate = moment(date).format(formatDate + " " + formatTime);
  }
  return returnDate;
};
